import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { HotelCardContext } from 'components/HotelCardContext';
import { getUserMeasurementSystem } from 'modules/meta/selectors';
import { getDistanceFromTarget, State } from 'modules/sapiSearch/selectors';
import { getGeoDetails, getIsUserOrUrlLocationSearch, getPlaceCategory, getSearchDisplayName } from 'modules/search/selectors';
import { Text } from '@daedalus/atlas/Text';
import { convertMilesToKm, getDistanceFromMessage, messages } from '@daedalus/core/src/utils/distanceFrom';
const _exp = /*#__PURE__*/() => Text;
const Message = /*#__PURE__*/styled(_exp())({
  name: "Message",
  class: "mkuqn80",
  propsAsIs: true
});

/**
 * This component is a modified copy of the DistanceFrom component in the client package.
 * When cleaning up the experimental no offers card, we remove the other component and use this one instead.
 */
export const HotelDistance = () => {
  const {
    formatMessage
  } = useIntl();
  const {
    hotelId
  } = useContext(HotelCardContext);
  const userMeasurementSystem = useSelector(getUserMeasurementSystem);
  const searchDisplayName = useSelector(getSearchDisplayName);
  const placeCategory = useSelector(getPlaceCategory);
  const {
    featureType: geoDetailsFeatureType,
    shortName: geoDetailsShortName
  } = useSelector(getGeoDetails) || {};
  const fromUserLocation = useSelector(getIsUserOrUrlLocationSearch);
  const distanceFromTarget = useSelector((state: State) => getDistanceFromTarget(state, hotelId));
  const distanceFromMessage = getDistanceFromMessage({
    fromUserLocation,
    geoDetailsFeatureType,
    geoDetailsShortName,
    placeCategory: placeCategory || 0
  });

  // Show nothing when distance or message not provided
  if (!distanceFromTarget || !distanceFromMessage) return null;
  const [unitMessage, convertedDistance] = userMeasurementSystem === 'imperial' ? [messages.distanceAsMiles, distanceFromTarget] : [messages.distanceAsKm, convertMilesToKm(distanceFromTarget)];
  const message = formatMessage(distanceFromMessage, {
    distance: convertedDistance.toFixed(1),
    unit: formatMessage(unitMessage),
    targetName: geoDetailsShortName ?? searchDisplayName
  });
  return <div id={`HotelCardMobileDistanceFrom-${hotelId}`}>
      <Message variant="bodyXS" colorPath="border.neutral.c600">
        {message}
      </Message>
    </div>;
};

require("./HotelDistance.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelDistance.tsx");